import { connect } from "react-redux";
import OrganizationUtils from "../../../utils/organization";
import Invitations, {
  InvitationsDOMProps,
  InvitationsProps as _InvitationsProps,
  InvitationsModalVisibilityProps
} from "./invitations-container";
import { AppState } from "../../../store/AppState";
import {
  PickReduxDispatchProps,
  PickReduxStateProps
} from "../../../util/typeUtil";
import {
  listOrganizationGroups,
  listOrganizationRoles,
  listOrganizationsOrganizationGroupInvitations
} from "../../../actions";
import { ActionSender } from "../../../model/ActionSender";
import AuthenticationUtils from "../../../utils/authentication";
import { addSenderArgument } from "../../../actions/actionHelpers";
import {OrganizationGroupInvitationWithExpiredStatus, populateExpiredStatus} from "../../../utils/invitation";

export { ModalKeys } from "./invitations-container";

export interface InvitationsProps
  extends InvitationsDOMProps,
    InvitationsModalVisibilityProps {}

// Input props provided to the wrapped component by this connect component, using mapStateToProps
type ReduxStateProps = PickReduxStateProps<_InvitationsProps, InvitationsProps>;
// Dispatch props provided to the wrapped component by this connect component
type ReduxDispatchProps = PickReduxDispatchProps<
  _InvitationsProps,
  InvitationsProps
>;

const sender: ActionSender = { key: "invitations" };

function mapStateToProps(state: AppState): ReduxStateProps {
  return {
    invitations: OrganizationUtils.selectOrganizationInvitations(state)?.map(populateExpiredStatus) as OrganizationGroupInvitationWithExpiredStatus[],
    groups: OrganizationUtils.selectOrganizationGroups(state),
    userName: AuthenticationUtils.selectAuthenticationUserDisplayName(state),
    userId: AuthenticationUtils.selectAuthenticationUserId(state),
    orgAdminRoleId: OrganizationUtils.selectOrgAdminRoleId(state)
  };
}

function areStatesEqual(next: AppState, prev: AppState): boolean {
  return (
    AuthenticationUtils.compareAuthenticationUserDisplayNameStates(
      next,
      prev
    ) &&
    AuthenticationUtils.compareAuthenticationUserIdStates(next, prev) &&
    OrganizationUtils.compareOrganizationRolesStates(next, prev) &&
    OrganizationUtils.compareOrganizationGroupsStates(next, prev) &&
    OrganizationUtils.compareOrganizationInvitationsStates(next, prev)
  );
}
const dispatchActions: ReduxDispatchProps = {
  onLoadOrganizationRoles: addSenderArgument(sender, listOrganizationRoles),
  onLoadInvitations: addSenderArgument(
    sender,
    listOrganizationsOrganizationGroupInvitations
  ),
  onLoadGroups: addSenderArgument(sender, listOrganizationGroups)
};

export default connect<
  ReduxStateProps,
  ReduxDispatchProps,
  InvitationsProps,
  AppState
>(mapStateToProps, dispatchActions, null, {
  areStatesEqual
})(Invitations);
